module.exports = "<menu></menu>\n<h3>Skills</h3>\n<div class=\"skillgroup\" *ngFor=\"let group of skillGroups\">\n    <div class=\"groupheader\">{{group.group}}</div>\n    <div class=\"skill\" *ngFor=\"let skill of group.skills\">\n        <span class=\"skillname\">{{skill.name}}</span>\n        <span class=\"skilllevel\">{{skillLevel[skill.level]}}</span>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/thunder/git/portfolier/src/app/+cv/skills/skills.html
// module id = ../../../../../src/app/+cv/skills/skills.html
// module chunks = 1